// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__39jYw","right":"Footer_right__7Z_w6","buttons":"Footer_buttons__3Leal"};